// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3249":"c8c7d9856f92b755","4619":"cd038b4f662f38c1"}[chunkId] + ".css";
};